export const AUTH_TOKEN_KEY = 'paperpal-auth-token';
